import ContactForm from "../../components/ContactForm/ContactForm";
import { useMemo } from "react";
import AnimatedScroll from "../../components/AnimatedScroll/AnimatedScroll";
import { getImage } from "../../config/imageConfig";

function Contact() {
  document.title = "Carpe Diem - Contact";

  const lat = 44.4428052;
  const lng = 2.370599;
  const label = encodeURIComponent("Carpe Diem Goutrens");

  const mapHref = useMemo(() => {
    if (typeof navigator === "undefined") {
      return `https://www.google.com/maps/place/Carpe+Diem/@44.442709,2.3712361,353m/data=!3m1!1e3!4m12!1m5!3m4!2zNDTCsDI2JzM0LjEiTiAywrAyMicxNC4yIkU!8m2!3d44.4428056!4d2.3706111!3m5!1s0x12ad791e25722dc3:0x4fa414964f8c8ec5!8m2!3d44.4428052!4d2.370599!16s%2Fg%2F11yf531s6h?entry=ttu&g_ep=EgoyMDI1MTEwNC4xIKXMDSoASAFQAw%3D%3D`;
    }

    const ua = navigator.userAgent || "";
    const isMobileUA = /Mobi|Android|iPhone|iPad|iPod/i.test(ua);

    if (isMobileUA) {
      if (/iPhone|iPad|iPod/i.test(ua)) {
        // ouvre Apple Maps sur iOS (marqueur)
        return `maps://maps.apple.com/?q=${label}&ll=${lat},${lng}`;
      } else if (/Android/i.test(ua)) {
        // ouvre l'app Maps sur Android (marqueur)
        return `geo:${lat},${lng}?q=${lat},${lng}(${label})`;
      }
    }

    // fallback pour desktop : ouvre Google Maps web (marqueur)
    return `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`;
  }, [lat, lng, label]);

  return (
    <div className="construction-content">
      <AnimatedScroll>
        <h1>Vous souhaitez nous posez une question ? </h1>
      </AnimatedScroll>
      <br />
      <AnimatedScroll>
        <div className="reservation-info" style={{ margin: "24px 0" }}>
          <span style={{ verticalAlign: "middle" }}>
            Pour toute réservation de table ou de chambre d'hôtes, veuillez nous
            téléphoner :
            <br />
            <br />
            <strong>
              <a
                className="linkScale"
                href="tel:+33563714445"
                style={{ color: "#fff", textDecoration: "underline" }}
              >
                <svg
                  width="22"
                  height="22"
                  fill="#fff"
                  style={{ verticalAlign: "middle", marginRight: "8px" }}
                  viewBox="0 0 24 24"
                >
                  <path d="M6.62 10.79a15.053 15.053 0 006.59 6.59l2.2-2.2a1 1 0 011.01-.24c1.12.37 2.33.57 3.58.57a1 1 0 011 1V20a1 1 0 01-1 1C10.07 21 3 13.93 3 5a1 1 0 011-1h3.5a1 1 0 011 1c0 1.25.2 2.46.57 3.58a1 1 0 01-.24 1.01l-2.2 2.2z"></path>
                </svg>
                +33 5 63 71 44 45
              </a>
            </strong>
          </span>
        </div>
        <div
          className="contact-info"
          style={{ marginBottom: "16px", color: "#fff" }}
        >
          <div>
            <a
              className="linkScale"
              href="https://www.google.com/maps/place/Carpe+Diem/@44.4429113,2.3708851,19.04z/data=!4m12!1m5!3m4!2zNDTCsDI2JzM0LjEiTiAywrAyMicxNC4yIkU!8m2!3d44.442815!4d2.3706!3m5!1s0x12ad791e25722dc3:0x4fa414964f8c8ec5!8m2!3d44.4428052!4d2.370599!16s%2Fg%2F11yf531s6h?entry=ttu&amp;g_ep=EgoyMDI1MDgwMy4wIKXMDSoASAFQAw%3D%3D"
              target="_blank"
              style={{ color: "#fff", textDecoration: "underline" }}
              rel="noopener noreferrer"
            >
              <svg
                width="18"
                height="18"
                fill="#fff"
                style={{ verticalAlign: "middle", marginRight: "6px" }}
                viewBox="0 0 24 24"
              >
                <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"></path>
              </svg>
              242 Route de Goutrens, Goutrens, France
            </a>
          </div>
          <div>
            <br />

            <a
              className="linkScale"
              href="mailto:contact@carpediem12.com"
              style={{ color: "#fff", textDecoration: "underline" }}
            >
              <svg
                width="18"
                height="18"
                fill="#fff"
                style={{ verticalAlign: "middle", marginRight: "6px" }}
                viewBox="0 0 24 24"
              >
                <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"></path>
              </svg>
              contact@carpediem12.com
            </a>
          </div>
        </div>
      </AnimatedScroll>
      <ContactForm />
      <AnimatedScroll>
        <div style={{ marginBottom: "10px", fontSize: "1.1rem" }}>
          Pour nous retrouver, suivez-nous sur nos réseaux :
        </div>
        <div className="social-links">
          <a
            className="devalls-link"
            href="https://www.facebook.com/p/CARPE-DIEM-12-61577135145308/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Facebook"
          >
            <svg width="32" height="32" fill="#fff" viewBox="0 0 24 24">
              <path d="M22.675 0h-21.35C.595 0 0 .592 0 1.326v21.348C0 23.408.595 24 1.325 24h11.495v-9.294H9.692V11.01h3.128V8.413c0-3.1 1.893-4.788 4.659-4.788 1.325 0 2.463.099 2.797.143v3.24l-1.918.001c-1.504 0-1.797.715-1.797 1.763v2.313h3.587l-.467 3.696h-3.12V24h6.116C23.406 24 24 23.408 24 22.674V1.326C24 .592 23.406 0 22.675 0"></path>
            </svg>
          </a>
          <a
            className="devalls-link"
            href="https://www.instagram.com/carpediem_goutrens/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
          >
            <svg width="32" height="32" fill="#fff" viewBox="0 0 24 24">
              <path d="M12 2.163c3.204 0 3.584.012 4.85.07 1.366.062 2.633.334 3.608 1.308.974.974 1.246 2.241 1.308 3.608.058 1.266.069 1.646.069 4.85s-.011 3.584-.069 4.85c-.062 1.366-.334 2.633-1.308 3.608-.974.974-2.241 1.246-3.608 1.308-1.266.058-1.646.069-4.85.069s-3.584-.011-4.85-.069c-1.366-.062-2.633-.334-3.608-1.308-.974-.974-1.246-2.241-1.308-3.608C2.175 15.647 2.163 15.267 2.163 12s.012-3.584.07-4.85c.062-1.366.334-2.633 1.308-3.608C4.515 2.567 5.782 2.295 7.148 2.233 8.414 2.175 8.794 2.163 12 2.163zm0-2.163C8.741 0 8.332.012 7.052.07 5.771.128 4.635.401 3.678 1.358c-.957.957-1.23 2.093-1.288 3.374C2.012 5.668 2 6.077 2 12c0 5.923.012 6.332.07 7.612.058 1.281.331 2.417 1.288 3.374.957.957 2.093 1.23 3.374 1.288C8.332 23.988 8.741 24 12 24s3.668-.012 4.948-.07c1.281-.058 2.417-.331 3.374-1.288.957-.957 1.23-2.093 1.288-3.374.058-1.28.07-1.689.07-7.612 0-5.923-.012-6.332-.07-7.612-.058-1.281-.331-2.417-1.288-3.374-.957-.957-2.093-1.23-3.374-1.288C15.668.012 15.259 0 12 0zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zm0 10.162a3.999 3.999 0 1 1 0-7.998 3.999 3.999 0 0 1 0 7.998zm6.406-11.845a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.881z"></path>
            </svg>
          </a>

          {/* TripAdvisor */}
          <a
            className="devalls-link"
            href="https://fr.tripadvisor.be/Restaurant_Review-g7269605-d33338686-Reviews-Carpe_Diem-Goutrens_Aveyron_Occitanie.html"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Tripadvisor"
            style={{
              display: "flex",
              alignItems: "center",
              marginLeft: "12px",
            }}
          >
            <svg
              width="32"
              height="32"
              viewBox="0 0 512 512"
              fill="#34e0a1"
              style={{ marginRight: "6px" }}
            >
              <circle cx="256" cy="256" r="256" fill="#fff" />
              <path
                d="M256 96c-88.4 0-160 71.6-160 160s71.6 160 160 160 160-71.6 160-160S344.4 96 256 96zm0 288c-70.7 0-128-57.3-128-128s57.3-128 128-128 128 57.3 128 128-57.3 128-128 128zm-64-128c0 35.3 28.7 64 64 64s64-28.7 64-64-28.7-64-64-64-64 28.7-64 64zm64 48c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"
                fill="#34e0a1"
              />
            </svg>
            TripAdvisor
          </a>
        </div>
      </AnimatedScroll>
      <div className="dev-info" style={{ fontSize: "1rem", color: "#fff" }}>
        <AnimatedScroll>Développé par</AnimatedScroll>
        <div
          className="dev-info"
          style={{
            marginTop: "24px",
            fontSize: "1rem",
            color: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "8px",
          }}
        >
          <AnimatedScroll>
            <a
              className="devalls-link"
              href="https://www.devalls.fr/devalls"
              target="_blank"
              style={{
                display: "inline-flex",
                alignItems: "center",
                textDecoration: "none",
              }}
              rel="noopener noreferrer"
            >
              <img
                src="https://www.devalls.fr/static/media/logoCopie.d64e63d7f879fa0b6e9c.png"
                alt="DevAlls logo"
                style={{ height: "100px", marginRight: "6px" }}
              />
            </a>
          </AnimatedScroll>
        </div>
      </div>
      <AnimatedScroll>
        <div className="map-screenshot">
          <a
            href={mapHref}
            target="_blank"
            rel="noopener noreferrer"
            title="Ouvrir la carte"
          >
            <img
              src={
                getImage("contact.mapScreenshot") || "/assets/images/maps.png"
              }
              alt="Carte : Carpe Diem Goutrens — cliquer pour ouvrir la carte"
              className="map-img"
            />
          </a>
        </div>
      </AnimatedScroll>
    </div>
  );
}

export default Contact;
